export const category = [
  {
    "id": 1,
    "category": "Agriculture",
    "title": "Insights, tips, and updates on agricultural practices and innovations.",
    "cover": "../images/category/agriculture.jpg"
  },
  {
    "id": 2,
    "category": "Arts and Culture",
    "title": "Creativity, arts, literature, and cultural events.",
    "cover": "../images/category/art.jpg"
  },
  {
    "id": 3,
    "category": "Business and Entrepreneurship",
    "title": "Insights, strategies, and advice for business success.",
    "cover": "../images/category/business.jpg"
  },
  {
    "id": 4,
    "category": "Education",
    "title": "Knowledge, skills, and educational resources.",
    "cover": "../images/category/education.jpg"
  },
  {
    "id": 5,
    "category": "Environment and Sustainability",
    "title": "Environmental issues, sustainability, and conservation.",
    "cover": "../images/category/environment.jpg"
  },
  {
    "id": 6,
    "category": "Music and Entertainment",
    "title": "Music, movies, TV shows, and entertainment.",
    "cover": "../images/category/entertainment.jpeg"
  },
  {
    "id": 7,
    "category": "Fashion",
    "title": "Fashion trends, style tips, and clothing inspiration.",
    "cover": "../images/category/fashion.jpg"
  },
  {
    "id": 8,
    "category": "Food and Cooking",
    "title": "Delicious recipes, cooking techniques, and culinary culture.",
    "cover": "../images/category/food.jpg"
  },
  {
    "id": 9,
    "category": "Fun",
    "title": "Enjoyable activities, games, and leisure ideas.",
    "cover": "../images/category/fun.jpg"
  },
  {
    "id": 10,
    "category": "Personal Finance",
    "title": "Financial management, saving, and investing advice.",
    "cover": "../images/category/finance.jpg"
  },
  {
    "id": 11,
    "category": "Health and Fitness",
    "title": "Wellness tips, fitness routines, and healthy living.",
    "cover": "../images/category/health.jpg"
  },
  {
    "id": 12,
    "category": "Life",
    "title": "Reflections, personal experiences, and life lessons.",
    "cover": "../images/category/life.jpg"
  },
  {
    "id": 13,
    "category": "Miscellaneous",
    "title": "A variety of topics, ideas, and discussions.",
    "cover": "../images/category/ca8.png"
  },
  {
    "id": 14,
    "category": "Sports",
    "title": "Sports news, events, and athletic activities.",
    "cover": "../images/category/sports.jpg"
  },
  {
    "id": 15,
    "category": "Science",
    "title": "Scientific discoveries, breakthroughs, and phenomena.",
    "cover": "../images/category/science.jpg"
  },
  {
    "id": 16,
    "category": "Travel",
    "title": "Travel destinations, tips, and adventures.",
    "cover": "../images/category/travel.jpg"
  },
  {
    "id": 17,
    "category": "Technology",
    "title": "Latest innovations, tech news, and gadgets.",
    "cover": "../images/category/technology.png"
  },
  {
    "id": 18,
    "category": "Uncategorized",
    "title": "Posts that don't fit into specific categories.",
    "cover": "../images/category/ca5.png"
  },
  {
    "id": 19,
    "category": "Weather",
    "title": "Updates, forecasts, and discussions on weather patterns.",
    "cover": "../images/category/weather.jpg"
  }
]
